import { createIcon } from '../shared'

const ShareIcon = createIcon(
  ({ color }) => (
    <path
      d="M13.125 3.81022C13.1252 3.65213 13.1717 3.49758 13.2588 3.36565C13.3459 3.23372 13.4698 3.13021 13.615 3.0679C13.7603 3.0056 13.9207 2.98724 14.0763 3.01509C14.2319 3.04295 14.3759 3.11579 14.4906 3.22462L22.3218 10.6826C23.0106 11.339 22.9866 12.4466 22.2702 13.0718L14.4642 19.883C14.3471 19.9847 14.2033 20.0506 14.0499 20.0728C13.8964 20.0951 13.7398 20.0728 13.5987 20.0085C13.4576 19.9443 13.3379 19.8409 13.2539 19.7105C13.1699 19.5802 13.1252 19.4285 13.125 19.2734V16.1882C13.125 16.1882 4.743 14.6786 2.055 19.613C1.8042 20.0738 0.8274 20.2346 1.0266 17.939C1.857 13.715 3.5538 7.11862 13.125 7.11862V3.81022Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'ShareIcon',
)

export { ShareIcon }
